import React, { CSSProperties } from "react";
import { Col, Row, Typography } from "antd";
import { DragAndDropIcon, PencilIcon, TrashIcon } from "@/icons/primary";

type Props = {
  question: string;
  answer: string;
  style?: CSSProperties;
  draggableControlProps?: any;
  onEdit?: (data: { question: string; answer: string }) => void;
  onDelete?: (data: { question: string; answer: string }) => void;
  dragAndDropIcon?: React.ReactNode;
  dragged?: boolean;
};

export const FaqItem: React.FC<Props> = ({
  question,
  answer,
  style,
  draggableControlProps,
  onEdit,
  onDelete,
  dragAndDropIcon,
  dragged,
}) => {
  return (
    <Row
      gutter={[0, 12]}
      style={{
        background: "white",
        borderBottom: dragged ? "none" : "1px solid #DFE2E6",
        paddingBottom: "20px",
        ...style,
        ...(dragged && {
          boxShadow: "0px 0px 40px rgba(112, 105, 89, 0.1)",
        }),
      }}
    >
      <Col span={24}>
        <Row style={{ justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          {dragAndDropIcon && <Col span={2}>{dragAndDropIcon}</Col>}

          <Col span={18}>
            <Row align='middle'>
              <div>
                <Typography.Text
                  className='body-2'
                  style={{ fontSize: "14px", fontWeight: "600", lineHeight: "26px" }}
                >
                  {question}
                </Typography.Text>
                <div
                  dangerouslySetInnerHTML={{ __html: answer }}
                  style={{ fontSize: "14px", fontWeight: "400", color: "#5E678C" }}
                />
              </div>
            </Row>
          </Col>

          <Col span={4}>
            <Row gutter={20} justify='end'>
              <Col onClick={() => onEdit?.({ question, answer })}>
                <PencilIcon style={{ fontSize: "20px", color: "#5f668c", cursor: "pointer" }} />
              </Col>

              <Col onClick={() => onDelete?.({ question, answer })}>
                <TrashIcon style={{ fontSize: "24px", color: "#5f668c", cursor: "pointer" }} />
              </Col>

              {draggableControlProps && (
                <Col {...draggableControlProps}>
                  <DragAndDropIcon style={{ fontSize: "20px", cursor: "pointer" }} />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
